import { render, staticRenderFns } from "./ContentViewSettingsCompanyFavorite.vue?vue&type=template&id=193ae9c6&scoped=true&"
import script from "./ContentViewSettingsCompanyFavorite.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsCompanyFavorite.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsCompanyFavorite.vue?vue&type=style&index=0&id=193ae9c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ae9c6",
  null
  
)

export default component.exports